export const validateArticle = (article) => {
  console.log('Validating article:', article);
  const errors = [];

  // Validate required fields
  if (!article.title) errors.push('Title is required');
  if (!article.source) errors.push('Source is required');
  if (!article.date) errors.push('Date is required');

  // Validate image
  if (article.image) {
    console.log('Validating image:', article.image);
    if (!article.image.fields?.file?.url) {
      errors.push('Image URL is required');
    }
  }

  // Validate product images
  if (article.productImages) {
    console.log('Validating product images:', article.productImages);
    article.productImages.forEach((image, index) => {
      if (!image.fields?.file?.url) {
        errors.push(`Product image ${index + 1} URL is required`);
      }
    });
  }

  // Validate performance features
  if (article.performanceFeatures) {
    console.log('Validating performance features:', article.performanceFeatures);
    if (!Array.isArray(article.performanceFeatures)) {
      errors.push('Performance features must be an array');
    }
  }

  // Validate product lineup
  if (article.productLineup) {
    console.log('Validating product lineup:', article.productLineup);
    if (!Array.isArray(article.productLineup)) {
      errors.push('Product lineup must be an array');
    }
  }

  // Validate contact
  if (article.contact) {
    console.log('Validating contact:', article.contact);
    if (!article.contact.name) errors.push('Contact name is required');
    if (!article.contact.email) errors.push('Contact email is required');
    if (!article.contact.phone) errors.push('Contact phone is required');
  }

  // Validate tags
  if (article.tags) {
    console.log('Validating tags:', article.tags);
    if (!Array.isArray(article.tags)) {
      errors.push('Tags must be an array');
    }
  }

  const isValid = errors.length === 0;
  console.log('Validation result:', { isValid, errors });
  return { isValid, errors };
};

export const transformArticle = (article) => {
  console.log('Transforming article:', article);
  
  // Ensure arrays are properly initialized
  const performanceFeatures = Array.isArray(article.performanceFeatures) 
    ? article.performanceFeatures 
    : [];
  
  const productLineup = Array.isArray(article.productLineup)
    ? article.productLineup
    : [];

  console.log('Transformed performance features:', performanceFeatures);
  console.log('Transformed product lineup:', productLineup);

  const transformedArticle = {
    title: article.title,
    excerpt: article.excerpt || '',
    content: article.content || {},
    additionalContent: article.additionalContent || {},
    postContactContent: article.postContactContent || null,
    source: article.source,
    date: article.date,
    image: article.image,
    productImages: article.productImages || [],
    performanceFeatures,
    productLineup,
    contact: article.contact || null,
    tags: article.tags || []
  };

  console.log('Transformed article:', transformedArticle);
  return transformedArticle;
}; 